import React, { Component, Fragment } from "react";
import { Table, Select, Input, Modal } from "antd";

import ChangePath from "../../ServiceApi";

const { Option } = Select;
const { TextArea } = Input;


class ApproveList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: [
        {
          key: "1",
          material_code: "BACC0100001",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
          item_desc: {
            item_name: "Monitor",
            description: "Can Watch Stuff",
            item_qty: 10,
            item_price: "300 Baht",
            item_total_price: 3000,
          },
        },
        {
          key: "2",
          material_code: "BACC0100002",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
          item_desc: {
            item_name: "Monitor",
            description: "Can Watch Stuff",
            item_qty: 10,
            item_price: "300 Baht",
            item_total_price: 3000,
          },
        },
        {
          key: "3",
          material_code: "BACC0100003",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
          item_desc: {
            item_name: "Monitor",
            description: "Can Watch Stuff",
            item_qty: 10,
            item_price: "300 Baht",
            item_total_price: 3000,
          },
        },
        {
          key: "5",
          material_code: "BACC0100004",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
        },
        {
          key: "6",
          material_code: "BACC0100005",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
        },
        {
          key: "7",
          material_code: "BACC0100006",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
        },
        {
          key: "8",
          material_code: "BACC0100007",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
        },
        {
          key: "9",
          material_code: "BACC0100008",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
        },
        {
          key: "10",
          material_code: "BACC0100009",
          material_type: "Module",
          material_name: "XXXXXXX",
          description: "จอ LG 55 นิ้ว",
          warehouse: "BKK - BANGKOK",
          sub_warehouse: "Bangkok north",
          unit: "Each",
          qty: 100,
          in: "100",
          out: "10",
          doc_status: "Wait Approve",
        },
      ],
      columns: [
        {
          title: "Material Code.",
          dataIndex: "material_code",
          key: "numaterial_codember",
          sorter: (a, b) => a.material_code.length - b.material_code.length,
        },
        {
          title: "Material Type.",
          dataIndex: "material_type",
          key: "material_type",
          sorter: (a, b) => a.material_type.length - b.material_type.length,
        },
        {
          title: "Material Name.",
          dataIndex: "material_name",
          key: "material_name",
          sorter: (a, b) => a.material_name.length - b.material_name.length,
        },
        {
          title: "Description",
          dataIndex: "description",
          key: "description",
          sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Warehouse",
          dataIndex: "warehouse",
          key: "warehouse",
          sorter: (a, b) => a.warehouse.length - b.warehouse.length,
        },
        {
          title: "Sub Warehouse",
          dataIndex: "sub_warehouse",
          key: "sub_warehouse",
          sorter: (a, b) => a.sub_warehouse.length - b.sub_warehouse.length,
        },
        {
          title: "Unit",
          dataIndex: "unit",
          key: "unit",
          sorter: (a, b) => a.unit.length - b.price.length,
        },
        {
          title: "Qty",
          dataIndex: "qty",
          key: "qty",
          sorter: (a, b) => a.qty - b.qty,
        },
        {
          title: "In",
          render: (item) => (
            <a style={{ color: "#10FF01" }}>
              {item["in"] != undefined ? item["in"] : ""}
            </a>
          ),
          sorter: (a, b) => a.in - b.in,
        },
        {
          title: "Out",
          render: (item) => (
            <a className="c-red">
              {item["out"] != undefined ? item["out"] : ""}
            </a>
          ),
          sorter: (a, b) => a.out - b.out,
        },
        {
          title: "Doc Status",
          align: "center",
          render: (item) => (
            <div
              style={{
                borderRadius: "12px",
                backgroundColor: "#FFDEA0",
                width: "auto",
                height: "auto",
                textAlign: "center",
                padding: "0.03rem",
              }}
            >
              {item["doc_status"] != undefined ? item["doc_status"] : ""}
            </div>
          ),
          sorter: (a, b) => a.doc_status - b.doc_status,
        },
        {
          title: "Action",
          align: "center",
          dataIndex: "material_code",
          key: "material_code",
          render: (item) => (
            <div>
              <button onClick={() => this.onView(item)}>
                <img src={ChangePath.absoluteUrl("/icon/action.svg")} />
              </button>
            </div>
          ),
        },
      ],
      modal_columns: [
        {
          title: "Item",
          render: (item) => (
            <span>
              {item["item_desc"] != undefined
                ? item["item_desc"]["item_name"]
                : ""}
            </span>
          ),
          // sorter: (a, b) => a.material_code.length - b.material_code.length,
        },
        {
          title: "Description",
          render: (item) => (
            <span>
              {item["item_desc"] != undefined
                ? item["item_desc"]["description"]
                : ""}
            </span>
          ),
          // sorter: (a, b) => a.material_type.length - b.material_type.length,
        },
        {
          title: "Quantity",
          render: (item) => (
            <span>
              {item["item_desc"] != undefined
                ? item["item_desc"]["item_qty"]
                : ""}
            </span>
          ),
          // sorter: (a, b) => a.material_name.length - b.material_name.length,
        },
        {
          title: "Price",
          render: (item) => (
            <span>
              {item["item_desc"] != undefined
                ? item["item_desc"]["item_price"]
                : ""}
            </span>
          ),
          // sorter: (a, b) => a.description.length - b.description.length,
        },
        {
          title: "Total",
          render: (item) => (
            <span>
              {item["item_desc"] != undefined
                ? item["item_desc"]["item_total_price"]
                : ""}
            </span>
          ),
          // sorter: (a, b) => a.warehouse.length - b.warehouse.length,
        },
      ],
    };
  }

  onView(id) {
    this.setState({
      visible: true,
      // material_code: id
    });
  }

  OnViewApprove(id) {
    this.setState({
      visible_approve: true,
    });
  }

  OnViewReject(id) {
    this.setState({
      visible_reject: true,
    });
  }

  OnViewRejectSuccess(id) {
    this.setState({
      visible_reject: false,
      visible_reject_success: true,
    });
  }

  renderModal() {
    const {
      visible,
      // material_code,
      modal_columns,
      data,
      value,
    } = this.state;

    return (
      <Modal
        centered
        visible={visible}
        footer={null}
        closable={false}
        width={800}
        bodyStyle={{
          paddingTop: "0",
          paddingLeft: "15px",
          paddingRight: "15px",
          paddingBottom: "0",
        }}
      >
        <div className="row">
          <div
            className="col"
            style={{
              backgroundColor: "#0500A3",
              height: "112px",
              borderBottom: "5px solid #EBCD00",
            }}
          >
            <div className="d-flex justify-content-between">
              <div className="col mt-5 ml-5">
                <img src={ChangePath.absoluteUrl("/logo/Plan_B_logo.svg")} />
              </div>
              <div
                className="col-4 mt-4"
                style={{ color: "#FFFFFF", lineHeight: "2rem" }}
              >
                <div className="row">
                  <div className="col-4">No.</div>
                  <div className="col-8">AP-201905-0271</div>
                </div>
                <div className="row">
                  <div className="col-4">Date.</div>
                  <div className="col-8">11/11/2020</div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <div className="col-9"></div>
            </div>
          </div>
        </div>

        <div className="row mt-3 ml-1 mr-1">
          <div className="col">
            <div
              className="mb-3"
              style={{ fontSize: "40px", fontWeight: "bold", color: "#0500A3" }}
            >
              REQUISITION
            </div>
            <div className="d-flex justify-content-between approve-modal">
              <div
                className="col-8 approve-modal-child"
                style={{ fontSize: "18px" }}
              >
                <div className="row">
                  <div className="col-6">Warehouse</div>
                  <div className="col-6">Bkk - Bangkok</div>
                </div>
                <div className="row">
                  <div className="col-6">Sub Warehouse</div>
                  <div className="col-6">Bangkok North</div>
                </div>
                <div className="row">
                  <div className="col-6">Req Name</div>
                  <div className="col-6">กัน</div>
                </div>
                <div className="row">
                  <div className="col-6">Team</div>
                  <div className="col-6">Bus</div>
                </div>
                <div className="row">
                  <div className="col-6">Team Lead</div>
                  <div className="col-6">อาร์ม</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <img
              style={{ width: "250px", height: "250px" }}
              src={ChangePath.absoluteUrl("/img/Checking_boxes_rafiki.svg")}
            />
          </div>
        </div>

        <div
          className="row c-white"
          style={{
            margin: "0px 35px 0px 35px",
            padding: "0.5rem",
            backgroundColor: "#0500a3",
            fontFamily: "MontserratM",
          }}
        >
          Item Description
        </div>

        <div
          style={{
            marginLeft: "15px",
            marginRight: "15px",
            padding: "20px",
            paddingTop: "0",
            fontFamily: "MontserratM",
          }}
        >
          <Table
            pagination={false}
            columns={modal_columns}
            dataSource={data}
            onChange={this.handleChange}
            bordered={true}
          />
        </div>

        <div className="d-flex justify-content-between approve-modal-bottom">
          <div
            className="col-7 ml-4 approve-modal-child-bottom"
            style={{ fontSize: "18px" }}
          >
            <div className="row">
              <div className="col-6">Note/Comment</div>
              <div className="col-6"></div>
              <div className="col-12" style={{ margin: "2px 2px 0px 0px" }}>
                <TextArea value={value} onChange={this.onChange} />
              </div>
            </div>
            <div className="row">
              <div className="col-6">Request By</div>
              <div className="col-6">-</div>
            </div>
            <div className="row">
              <div className="col-6">Approved By</div>
              <div className="col-6">-</div>
            </div>
            <div className="row">
              <div className="col-6">Issued By</div>
              <div className="col-6">-</div>
            </div>
          </div>

          <div
            className="col-5 approve-modal-child-bottom"
            style={{ fontSize: "18px" }}
          >
            <div
              className="row"
              style={{
                backgroundColor: "#E8ECEF",
                margin: "3px",
                marginRight: "40px",
              }}
            >
              <div className="col-6">Sub Total</div>
              <div className="col-4" style={{ textAlign: "right" }}>
                -
              </div>
            </div>
            <div
              className="row"
              style={{
                backgroundColor: "#E8ECEF",
                margin: "3px",
                marginRight: "40px",
              }}
            >
              <div className="col-6">Total Amount</div>
              <div className="col-4" style={{ textAlign: "right" }}>
                -
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div
            className="col text-center d-flex justify-content-between mt-3"
            style={{ backgroundColor: "#F7F8FB" }}
          >
            <button
              type="reset"
              onClick={() => this.setState({ visible: false })}
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button
              type="reset"
              style={{ height: "40px", width: "200px", marginTop: "11px" }}
              onClick={() => this.setState({ visible: false })}
              className="btn btn-warning"
            >
              Approval Request
            </button>
            <button
              type="reset"
              onClick={() => this.setState({ visible: false })}
              className="btn btn-danger"
            >
              Reject
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  renderApproveButtonModal() {
    const { visible_approve } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_approve}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                <img src={ChangePath.absoluteUrl("/icon/approve_check.svg")} />
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  Approved Successfully
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() => this.setState({ visible_approve: false })}
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  renderRejectButtonModal() {
    const { visible_reject, value } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_reject}
          footer={null}
          closable={false}
          // width={300}
          bodyStyle={{ padding: "0px 0px 0px 0px" }}
        >
          <div
            style={{
              fontFamily: "MontserratM",
              fontWeight: "bold",
              color: "#0500A3",
            }}
          >
            <div className="row" style={{ padding: "10px 10px 10px 10px" }}>
              <div className="col text-left justify-content-between">
                Reject
              </div>
            </div>

            <div style={{ backgroundColor: "#f8f9fa" }}>
              <div className="row">
                <div className="col" style={{ margin: "25px 25px 25px 25px" }}>
                  <div className="ml-3" style={{ color: "#6f6f6f" }}>
                    Reason <span style={{ color: "red" }}>*</span>
                  </div>
                  <div
                    className="col-12 text-center justify-content-between"
                    style={{ margin: "2px 2px 0px 0px" }}
                  >
                    <TextArea
                      value={value}
                      autoSize={{ minRows: 8, maxRows: 10 }}
                      onChange={this.onChange}
                      placeholder={"เขียนเป็นรายละเอียด"}
                    />
                  </div>
                </div>
                ,
              </div>

              <div className="row">
                <div className="col text-center justify-content-between">
                  <button
                    type="reset"
                    style={{ width: "120px" }}
                    onClick={() => this.setState({ visible_reject: false })}
                    className="btn btn-secondary"
                  >
                    Cancel
                  </button>
                  <button
                    type="reset"
                    style={{ width: "120px" }}
                    onClick={() =>
                      this.OnViewRejectSuccess(
                        this.renderRejectButtonSuccessModal
                      )
                    }
                    className="btn btn-danger"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  renderRejectButtonSuccessModal() {
    const { visible_reject_success, visible_reject } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_reject_success}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                <img src={ChangePath.absoluteUrl("/icon/approve_check.svg")} />
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  <span style={{ color: "red" }}>Rejected</span> Successfully
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>
                    this.setState({ visible_reject_success: false })
                  }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  // // For Showing check button
  state = {
    selectedRowKeys: [],
  };
  onSelectChange = (selectedRowKeys) => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  render() {
    const { data, columns } = this.state;
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectedRowKeysChange,
    };
    return (
      <Fragment>
        {this.renderModal()}
        {this.renderApproveButtonModal()}
        {this.renderRejectButtonModal()}
        {this.renderRejectButtonSuccessModal()}
        <div className="row ml-1">
          <div className="col-1">
            <span>
              <Select
                style={{ width: 120 }}
                placeholder="Select"
                defaultValue="All"
                onChange={this.onSort}
              >
                <Option value="">BKK</Option>
                <Option value="">SOUTH</Option>
                <Option value="">CENTER</Option>
              </Select>
            </span>
          </div>
          <div className="col-3">
            <Input.Search
              placeholder="Search"
              onSearch={(value) => console.log(value)}
              className="mb-4"
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className="card-table-ma">
            <div
              className="row"
              style={{
                background: "#F8FAFB",
                marginLeft: "0px",
                marginRight: "0px",
              }}
            >
              <div
                className="col-2"
                style={{
                  background: "#000F9F",
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                <div style={{ height: "36px", marginTop: "10px" }}>
                  <span>Approve List</span>
                </div>
              </div>
              <div className="col-8"></div>
              <div
                className="col-2"
                style={{ textAlign: "right", marginTop: "10px" }}
              >
                <span>Show</span>
                <select style={{ marginLeft: "10px", color: "#000F9F" }}>
                  <option value="A">10</option>
                  <option value="B">20</option>
                  <option value="C">50</option>
                </select>
                <span style={{ marginLeft: "10px" }}>Entries</span>
              </div>
            </div>
            <div className="body mt-3">
              <button
                style={{
                  height: "30px",
                  width: "100px",
                  marginLeft: "2rem",
                  fontSize: "12px",
                }}
                className="btn btn-warning"
                onClick={() =>
                  this.OnViewApprove(this.renderApproveButtonModal)
                }
              >
                Approve
              </button>
              <button
                style={{
                  height: "30px",
                  width: "100px",
                  marginLeft: "2rem",
                  borderRadius: "0px",
                  fontSize: "12px",
                }}
                className="btn btn-danger"
                onClick={() => this.OnViewReject(this.renderRejectButtonModal)}
              >
                Reject
              </button>
              <div
                style={{
                  marginLeft: "15px",
                  marginRight: "15px",
                  padding: "20px",
                }}
              >
                <Table
                  rowSelection={rowSelection}
                  columns={columns}
                  dataSource={data}
                  onChange={this.handleChange}
                />

                <div
                  style={{
                    height: "36px",
                    marginTop: "10px",
                    top: "915px",
                    position: "absolute",
                    color: "#6F6F6F",
                  }}
                >
                  <span>Showing</span>
                  <span style={{ marginLeft: "5px" }}>1</span>
                  <span style={{ marginLeft: "5px" }}>To</span>
                  <span style={{ marginLeft: "5px" }}>10</span>
                  <span style={{ marginLeft: "5px" }}>Of</span>
                  <span style={{ marginLeft: "5px" }}>1,000</span>
                  <span style={{ marginLeft: "5px" }}>Entries</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ApproveList;
